import UserStorage from './UserStorage'

/**
 * IM 系统页面（serviceConversation → 内嵌 im_client 的 iframe）相关常量与工具。
 *
 * 背景：IM 页面原来在 serviceConversation.vue 里直接渲染 iframe。路由切走时页面组件会被 keep-alive
 * 移入「脱离文档的缓存容器」，iframe 随之脱离文档；切回 IM 页面时 iframe 被重新插入文档，浏览器会
 * 重新加载页面（im_client 整个刷新），当前正在咨询的用户、聊天记录和输入内容全部丢失。
 *
 * 常驻方案：命中该路由时由 Home.vue 常驻渲染一个 iframe，路由切换只切换 v-show 显隐，
 * iframe 始终留在文档里，因此从 IM 切到订单列表再切回来不会刷新。
 * 该方案暂时关闭，由 serviceConversation.vue 自己渲染 iframe；恢复时开启下方开关。
 */

// 暂时关闭 d69d95d7 的 IM 常驻 iframe；恢复时改为 true。
export const ENABLE_PERSISTENT_IM_FRAME = false

// 命中该 pageUrl 的菜单路由使用「常驻 iframe」渲染（不能改用 id 判断：菜单 id 由后端配置）
const PERSISTENT_IM_FRAME_PAGE = /(^|\/)serviceChat\/serviceConversation\/?$/

// 写进路由 meta 的标记字段：该路由需要使用 Home.vue 常驻托管的 IM iframe
export const PERSISTENT_IFRAME_META_KEY = 'persistentIframe'

// Home.vue 通过 provide 告诉 serviceConversation.vue：iframe 已由布局常驻托管，组件不需要再渲染
export const IM_FRAME_PROVIDE_KEY = Symbol('imFrameHostedByLayout')

export function isPersistentIframePage(pageUrl) {
  return ENABLE_PERSISTENT_IM_FRAME && PERSISTENT_IM_FRAME_PAGE.test(pageUrl || '')
}

// im_client 的地址：de / userId / chkCode 由登录信息拼出，im_client 用它换取 IM 签名
export function getImFrameUrl() {
  const url = process.env.VUE_APP_AI_HOST
  if (!url) return ''
  return `${url}?de=${UserStorage.getUserInfo('de')}&userId=${UserStorage.getUserInfo('userId')}&chkCode=${UserStorage.getUserInfo('token')}`
}
